module.exports = __webpack_public_path__ + "static/media/rxjs.55d01d15.svg";